import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import OTP from '@/components/OTP/OTP';
import { getOrFetchConfiguration } from '@/utils/getConfiguration';
import { getCMSHomepageGrid } from '@/api/cms';
import { getOrFetchHeaderData } from '@/utils/headerCalls';
import LoginLayout from '@/components/LoginLayout/LoginLayout';
import getLayoutProps from '@/utils/layout/layout';

export default function OTPPage({ logo, loginLogo, loginConfig, loginImage, responsiveLogo }) {
  const [config, setConfig] = useState();
  const router = useRouter();
  loginImage === '' ? (loginConfig = 0) : null;

  useEffect(() => {
    async function getConfiguration() {
      const configuration = await getOrFetchConfiguration();
      setConfig(configuration);
      return;
    }
    getConfiguration();
  }, []);

  useEffect(() => {
    if (!router?.query?.pageFrom) {
      router.replace('/');
      return;
    }
  }, []);

  if (!router?.query?.pageFrom) {
    return null;
  }

  return (
    <>
      {config && (
        <LoginLayout type={loginConfig} image={loginImage} responsiveLogo={responsiveLogo}>
          <OTP
            config={config}
            pageFrom={router?.query?.pageFrom}
            logo={loginLogo ? loginLogo : logo}
            type={loginConfig}
          />
        </LoginLayout>
      )}
    </>
  );
}

export async function getStaticProps(context) {
  const { responsiveLogo } = await getLayoutProps({ headerProps: { selectedIndex: -1 } }, context.locale);
  const [{ data: logoData }, { data: loginLogoData }, { data: loginAllData }] = await Promise.all([
    getCMSHomepageGrid('header_logo', context.locale),
    getOrFetchHeaderData('login_logo', context.locale),
    getOrFetchHeaderData('login_page', context.locale),
  ]);
  const logo = logoData.data[0].content.logo.url;
  const loginLogo = loginLogoData.data[0].content.login_logo.url;
  const loginConfig = loginAllData.data[0].content.configuration;
  const loginImage = loginAllData.data[0].content.image?.url ? loginAllData.data[0].content.image?.url : '';

  const messages = {
    common: (await import(`../../../prebuild-data/i18n/${context.locale}/common.json`)).default,
    otp: (await import(`../../../prebuild-data/i18n/${context.locale}/otp.json`)).default,
  };

  return {
    props: {
      responsiveLogo,
      logo,
      loginLogo,
      loginConfig,
      loginImage,
      messages,
    },
  };
}
